<div class="auth-container">
  <div class="auth-background">
    <div class="gradient-orb gradient-orb-1"></div>
    <div class="gradient-orb gradient-orb-2"></div>
    <div class="gradient-orb gradient-orb-3 mobile-hide"></div>
  </div>

  <div class="auth-content">
    <div class="auth-card demo-card">
      <!-- Kopfzeile: Marke + Demo-Kennzeichnung + Theme-Toggle.
           Die Demo-Marke sitzt hier statt über der Überschrift — als eigene Zeile kostete sie
           32 px, ohne mehr zu sagen. -->
      <div class="desk-top">
        <div class="fp-brand">
          <img src="assets/img/logo-text.svg" alt="FixPlaner" class="logo" />
        </div>
        <span class="demo-chip">
          <i class="fa-solid fa-flask"></i>
          {{ "DEMO.WELCOME_BADGE" | translate }}
        </span>
        <div class="auth-top-actions">
          <xds-icon-button
            [icon]="'fa-light ' + getThemeIconClass()"
            [ariaLabel]="'REG_THEME_TOGGLE_LABEL' | translate"
            (clicked)="toggleTheme()"
          ></xds-icon-button>
        </div>
      </div>

      <!-- Begrüßung. Die Überschrift nennt jetzt den Nutzen statt zu grüßen: „Willkommen bei
           FixPlaner" sagte nichts, was das Logo eine Zeile darüber nicht schon sagt. -->
      <div class="desk-greet demo-greet">
        <h1>
          {{ "DEMO.WELCOME_TITLE_LINE" | translate }}
          <span class="grad">{{ "DEMO.WELCOME_TITLE_ACCENT" | translate }}</span>
        </h1>
        <p class="lede">{{ "DEMO.WELCOME_SUBTITLE" | translate }}</p>
      </div>

      <!-- Erwartungs-Management als Faktenzeile.
           Vorher drei Blöcke mit Icon-Kachel, Titel und zwei Zeilen Begründung: 214 px, plus
           116 px Banner darunter, das die dritte Aussage ein zweites Mal machte. Die Aussagen
           bleiben alle drei — Beispieldaten sind da, 48 Stunden, isoliert —, nur ihre Begründung
           entfällt. Die Kernaussage „wird nicht übernommen" steht jetzt im Rechtstext unter dem
           Startknopf, also weiterhin vor dem Klick. -->
      <ul class="demo-facts">
        <li class="demo-fact">
          <i class="fa-light fa-calendar-days" aria-hidden="true"></i>
          {{ "DEMO.FACT_DATA" | translate }}
        </li>
        <li class="demo-fact demo-fact--time">
          <i class="fa-light fa-clock" aria-hidden="true"></i>
          {{ "DEMO.FACT_TIME" | translate }}
        </li>
        <li class="demo-fact demo-fact--shield">
          <i class="fa-light fa-shield-halved" aria-hidden="true"></i>
          {{ "DEMO.FACT_SANDBOX" | translate }}
        </li>
      </ul>

      <!-- Branchenwahl: bestimmt die Beispieldaten der Demo-Firma und die Vorschläge des
           KI-Assistenten. Kam der Besucher von einer Branchen-Landingpage, ist bereits
           ausgewählt. Bewusst überspringbar — der Startknopf bleibt bedienbar. -->
      <div class="demo-industry">
        <!-- Bewusst KEIN `xds-form-field`: Diese Seite ist kein Formular, und der Rahmen
             brächte Hint-/Fehler-/Pflichtfeld-Maschinerie mit, von der hier nichts gebraucht
             wird. Die Gruppe zeigt stattdessen per `labelledBy` auf diesen Text — derselbe
             Vertrag, den das Kit für freistehende Auswahlgruppen vorsieht. -->
        <p class="demo-industry-label" id="demo-industry-label">
          {{ "DEMO.INDUSTRY_QUESTION" | translate }}
        </p>
        <!-- Der rote Rahmen im Fehlerfall läuft über `outline`, nicht `border`: Outline nimmt
             keinen Platz im Fluss ein, die Kacheln springen beim Erscheinen also nicht. -->
        <xds-tile-radio-group
          class="demo-industry-group"
          [class.demo-industry-group--invalid]="industryMissing"
          labelledBy="demo-industry-label"
          [describedBy]="industryMissing ? 'demo-industry-error' : undefined"
          [options]="industryOptions"
          [columns]="2"
          [ngModel]="selectedIndustry"
          (ngModelChange)="selectIndustry($event)"
        >
          <!-- Rich-Content-Slot: Icon LINKS neben Name und Beispielzeile. Auswahl-Kreis, Tastatur
               (Pfeiltasten, Home/End, ein Tabstopp) und `role="radio"` bleiben beim Kit.
               Die Zeilenform statt der gestapelten halbiert die Kachelhöhe (128 → ~58 px): der
               Name bleibt einzeilig, und das Icon beansprucht keine eigene Zeile mehr. -->
          <ng-template xdsTileRadioContent let-option>
            <span class="demo-industry-row">
              <span *ngIf="option.icon" class="demo-industry-icon">
                <i [class]="option.icon" aria-hidden="true"></i>
              </span>
              <span class="demo-industry-text">
                <span class="demo-industry-name">{{ option.labelKey | translate }}</span>
                <span class="demo-industry-hint">{{ option.descriptionKey | translate }}</span>
              </span>
            </span>
          </ng-template>
        </xds-tile-radio-group>

        @if (industryMissing) {
          <p
            class="demo-industry-error"
            id="demo-industry-error"
            role="alert"
            data-testid="demo-industry-error"
          >
            <i class="fa-light fa-circle-exclamation" aria-hidden="true"></i>
            {{ "DEMO.INDUSTRY_REQUIRED" | translate }}
          </p>
        }
      </div>

      <!-- Cloudflare Turnstile: still, solange die Prüfung ohne Zutun durchläuft; nach einem
           Fehlversuch sichtbar (appearance='always'), damit eine Challenge lösbar ist. -->
      <div id="demo-turnstile-container" class="demo-turnstile-container"></div>

      <!-- Die Bot-Prüfung ist der einzige Grund, aus dem der Startknopf gesperrt sein kann.
           Wenn sie scheitert, muss der Besucher das erfahren — sonst sieht er nur grau. -->
      @if (captchaState === 'failed') {
        <xds-banner variant="warning" icon="fa-light fa-shield-exclamation">
          {{ "DEMO.CAPTCHA_FAILED_TITLE" | translate }}
        </xds-banner>
      }

      <div class="demo-actions">
        <!-- `subdued` statt `disabled`, solange keine Branche gewählt ist: der Knopf sieht
             gedämpft aus, bleibt aber klickbar und löst damit die Beanstandung an der
             Kachelreihe aus. Ein hart gesperrter Knopf verschluckt seinen eigenen Klick
             (`XdsButtonComponent.onClick` ruft `stopPropagation`) und könnte nichts melden.
             `disabled` bleibt der Bot-Prüfung vorbehalten — das ist eine echte Sperre. -->
        <xds-button
          variant="primary"
          [block]="true"
          iconLeft="fa-light fa-play"
          [loading]="isSubmitting"
          [disabled]="startDisabled"
          [subdued]="startSubdued"
          [disabledReason]="captchaHintKey ? (captchaHintKey | translate) : undefined"
          (clicked)="onStart()"
          data-testid="demo-start-confirm"
        >
          {{ startLabelKey | translate }}
        </xds-button>

        @if (captchaHintKey) {
          <p
            class="demo-captcha-hint"
            [class.demo-captcha-hint--error]="captchaState === 'failed'"
            [attr.aria-live]="'polite'"
            data-testid="demo-captcha-hint"
          >
            @if (captchaState === 'loading') {
              <i class="fa-light fa-spinner-third fa-spin" aria-hidden="true"></i>
            } @else if (captchaState === 'interactive') {
              <i class="fa-light fa-hand-pointer" aria-hidden="true"></i>
            } @else {
              <i class="fa-light fa-circle-exclamation" aria-hidden="true"></i>
            }
            {{ captchaHintKey | translate }}
          </p>
        }

        @if (showCaptchaRetry) {
          <xds-button
            variant="secondary"
            [block]="true"
            iconLeft="fa-light fa-rotate-right"
            (clicked)="retryCaptcha()"
            data-testid="demo-captcha-retry"
          >
            {{ "DEMO.CAPTCHA_RETRY" | translate }}
          </xds-button>
        }

        <!-- Der Rechtstext steht VOR dem Anmelde-Link, weil er zur Aktion darüber gehört und
             die Kernaussage des entfallenen Banners trägt („wird nicht übernommen"). -->
        <p class="demo-legal">{{ "DEMO.WELCOME_LEGAL" | translate }}</p>

        <a class="link-text demo-login-link" [routerLink]="['/login']">
          {{ "DEMO.WELCOME_HAVE_ACCOUNT" | translate }}
        </a>
      </div>
    </div>
    <app-auth-legal-footer></app-auth-legal-footer>
  </div>
</div>
